export enum LabelSettingsOptions {
  BackgroundColor = 'BackgroundColor',
  BorderColor = 'BorderColor',
  FontColor = 'FontColor',
  FontSize = 'FontSize',
  BackgroundOpacity = 'BackgroundOpacity',
  PaddingHorizontal = 'PaddingHorizontal',
  PaddingVertical = 'PaddingVertical',
}
